export default {
  zh: {
    messages: {
      email: '請輸入有效的電郵地址。',
      validFullName: '請確保您輸入的名字和姓氏。'
    },
    custom: {
      email: {
        required: '請輸入電郵地址。'
      },
      fullName: {
        required: '請輸入有效的全名。',
        validateFullName: '請確保您輸入的名字和姓氏。'
      },
      firstName: {
        required: function () {
          return vueSupport?.featureFlags?.enableSignupRevamp ? '請填寫名字' : '請輸入名字。'
        }
      },
      lastName: {
        required: function () {
          return vueSupport?.featureFlags?.enableSignupRevamp ? '請填寫姓氏' : '請輸入姓氏。'
        }
      },
      dob: {
        required: '請輸入出生日期。'
      },
      password: {
        required: '請輸入密碼。',
        min: '密碼需8位字符或以上。'
      },
      postalCode: {
        required: '請輸入有效的郵政編碼。',
        min: function (_, min) {
          switch (I18n.siteCountryLs) {
            case 'au':
              return `請輸入${min}位有效的郵政編碼（例如0200)`
            case 'nz':
              return `請輸入${min}位有效的郵政編碼（例如02000)`
            case 'th':
              return `請輸入${min}位有效的郵政編碼`
            case 'my':
              return `請輸入${min}位有效的郵政編碼（例如02000)`
            case 'ph':
              return `請輸入${min}位有效的郵政編碼（例如0550)`
            case 'id':
              return `請輸入${min}位有效的郵政編碼`
            default:
              return `請輸入${min}位有效的郵政編碼`
          }
        },
        max: function (_, max) {
          switch (I18n.siteCountryLs) {
            case 'au':
              return `請輸入${max}位有效的郵政編碼（例如0200)`
            case 'nz':
              return `請輸入${max}位有效的郵政編碼（例如02000)`
            case 'th':
              return `請輸入${max}位有效的郵政編碼`
            case 'my':
              return `請輸入${max}位有效的郵政編碼（例如02000)`
            case 'ph':
              return `請輸入${max}位有效的郵政編碼（例如0550)`
            case 'id':
              return `請輸入${max}位有效的郵政編碼`
            default:
              return `請輸入${max}位有效的郵政編碼`
          }
        }
      },
      city: {
        required: '請選擇一個有效的城市。'
      },
      state: {
        required: '請選擇一個有效狀態。'
      },
      suburb: {
        required: '請選擇一個有效的郊區。'
      },
      addressOne: {
        required: '請輸入一個有效的地址。',
        max: (_, max) => `請確保您的地址少過${max}個字符`
      },
      district: {
        required: '請選擇一個有效的地區。'
      },
      province: {
        required: '請選擇一個有效的省區。'
      },
      addressAndBarangay: {
        required: '請輸入有效地址和巴蘭加。'
      },
      contactNumber: {
        required: '請輸入有效的聯繫電話。',
        numeric: '請確保您只輸入數字。',
        validatePhoneNumber: '您的電話號碼似乎不正確。'
      },
      mobileNumber: {
        required: '請輸入有效的手機號碼。',
        numeric: '請確保您只輸入數字。',
        validatePhoneNumber: '您的電話號碼似乎不正確。'
      },
      membershipId: {
        required: '請輸入你的會員號碼。'
      },
      distributionConsent: {
        required: '請接受私隱政策以繼續。'
      },
      nameOnCard: {
        required: '請輸入名字.',
        nameOnCardValidator: '請輸入有效的信用卡名稱.'
      },
      cardNumber: {
        required: '請輸入卡號.',
        cardNumberValidator: '請輸入一個有效的信用卡號碼.',
        cardAvailability: '不支援此信用卡。請嘗試使用其他信用卡。'
      },
      expiration: {
        required: '請輸入有效期.',
        expirationValidator: '請輸入有效的到期日期.'
      },
      cvc: {
        required: '請輸入cvc.',
        cvcValidator: '請輸入有效的cvc.'
      },
      phoneNumberCode: {
        required: '請選擇國家代碼。',
        phoneNumberValidator: '請輸入有效的國家代碼和電話號碼。'
      },
      phoneNumber: {
        required: '請輸入電話號碼。',
        phoneNumberValidator: '請輸入有效的國家代碼和電話號碼。'
      },
      selfCollectionSelection: {
        required: '請選擇一個收集選項.'
      },
      issuers: {
        required: '請選擇有效的付款方式。'
      },
      name: {
        unicodesValidator: '禁止使用表情符号ิ'
      },
      title: {
        unicodesValidator: '禁止使用表情符号ิ'
      },
      text: {
        unicodesValidator: '禁止使用表情符号'
      }
    }
  }
}
